import { render, staticRenderFns } from "./bookerHotels.vue?vue&type=template&id=0bbd64ff&scoped=true"
import script from "./bookerHotels.vue?vue&type=script&setup=true&lang=js"
export * from "./bookerHotels.vue?vue&type=script&setup=true&lang=js"
import style0 from "./bookerHotels.vue?vue&type=style&index=0&id=0bbd64ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbd64ff",
  null
  
)

export default component.exports